 // Lib
import { takeLatest, put } from 'redux-saga/effects';

// App
import { firebaseApp, timestamp } from '../firebase/index';
import { AppActions } from '../actions';

const handleCalculation = function* handleCalculation(action) {
  const {
    tweetNumber,
    tweetImpression,
    profileAccess,
    newFollower,
    nowFollower,
  } = action.payload;

  let resultImpression = tweetImpression / tweetNumber;
  let resultProfile = profileAccess / tweetImpression;
  let resultNewFollower = newFollower / profileAccess;
  let resultTweet = (1000 - nowFollower) / resultNewFollower / resultProfile / resultImpression; 

  resultImpression = (Number.isNaN(resultImpression) ||
    resultImpression === Number.POSITIVE_INFINITY ||
    resultImpression === Number.NEGATIVE_INFINITY) ? 0 : resultImpression.toFixed(1);
  resultProfile = (Number.isNaN(resultProfile) ||
    resultProfile === Number.POSITIVE_INFINITY ||
    resultProfile === Number.NEGATIVE_INFINITY) ? 0 : (resultProfile * 100).toFixed(1);
  resultNewFollower = (Number.isNaN(resultNewFollower) ||
    resultNewFollower === Number.POSITIVE_INFINITY ||
    resultNewFollower === Number.NEGATIVE_INFINITY) ? 0 : (resultNewFollower * 100).toFixed(1);
  resultTweet = (Number.isNaN(resultTweet) ||
    resultTweet === Number.POSITIVE_INFINITY ||
    resultTweet === Number.NEGATIVE_INFINITY) ? 0 : resultTweet.toFixed(1);
  
  
  const isOver1000Follower = (nowFollower >= 1000) ? true : false;
    
  console.log(resultImpression, resultProfile, resultNewFollower, resultTweet);

  yield put(AppActions.setResult(
    resultImpression,
    resultProfile,
    resultNewFollower,
    resultTweet,
    isOver1000Follower,
  ));

  // Firestore初期設定
  const db = firebaseApp.firestore();
  db.settings({ timestampsInSnapshots: true });

  // Firestoreにデータを登録
  db.collection("results").add({
    tweetNumber: tweetNumber,
    tweetImpression: tweetImpression,
    profileAccess: profileAccess,
    newFollower: newFollower,
    nowFollower: nowFollower,
    resultNumber: resultTweet, 
    impPerTweet: resultImpression,
    profPerImp: resultProfile,
    newFollowerPerProf: resultNewFollower,
    timestamp: timestamp,
  })
  .then(function() {
  })
  .catch(function(error) {
      console.error("Error writing document: ", error);
  });
  
  // db.collection("results").orderBy("timestamp", "desc")
  // .get()
  // .then(function(querySnapshot) {
  //     querySnapshot.forEach(function(doc) {
  //         // doc.data() is never undefined for query doc snapshots
  //         console.log(doc.id, " => ", doc.data());
  //     });
  // })
  // .catch(function(error) {
  //     console.log("Error getting documents: ", error);
  // });
};

const AppSaga = function* AppSaga() {
  yield takeLatest(AppActions.CALCULATION, handleCalculation);
};
export default AppSaga;



// WEBPACK FOOTER //
// ./src/sagas/AppSaga.js